/* eslint-disable dot-notation */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectPageTitle, selectIsRightSidebar } from 'mt-react-common/reducer';

import Languages from './Languages';
import NewMessages from './NewMessages';
import Notifications from './Notifications';
import HeaderBalance from './HeaderBalance';
import logo from './../../../logo.svg';

// eslint-disable-next-line react/prefer-stateless-function
class Header extends Component {
  render() {
    return (
      <nav className="navbar navbar-fixed-top navbar-default navbar-header_center navbar-toggle_abs">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle navbar-toggle-left"
              data-toggle="sidebar-l"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <a
              href={process.env['ROUTE_BASENAME']}
              className=" hidden-xs navbar-brand"
            >
              <img src={logo} alt={process.env['APP_NAME']} />
            </a>
            <div className="navbar-select visible-xs">
              {this.props.isRightSidebar ? (
                <a
                  className="dropdown-toggle disabled-link"
                  data-toggle="sidebar-r"
                >
                  {this.props.pageTitle}
                </a>
              ) : (
                this.props.pageTitle
              )}
            </div>
          </div>
          <div className="collapse navbar-collapse">
            <ul className="nav navbar-nav navbar-right">
              <Languages />
              <NewMessages />
              <Notifications />
              <HeaderBalance />
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

Header.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  isRightSidebar: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  pageTitle: selectPageTitle(state),
  isRightSidebar: selectIsRightSidebar(state)
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/Header.js